import React, { FC, ReactNode } from 'react';
import dynamic from 'next/dynamic';
// import { useRouter } from 'next/router';

import { Box, useDisclosure } from '@chakra-ui/react';
// import { FiChevronLeft, FiMenu } from 'react-icons/fi';

const Header = dynamic(() => import('../Header/Header'));
const Footer = dynamic(() => import('../Footer/Footer'));
const MobileNav = dynamic(() => import('../Header/components/MobileNav'));
import WhatsappClip from '../WhatsappClip/WhatsappClip';
import CallAlfred from '../CallAlfred/CallAlfred';

interface DrawerWrapperProps {
  children: ReactNode;
}

const DrawerWrapper: FC<DrawerWrapperProps> = ({ children }) => {
  const {
    isOpen: mobileNavIsOpen,
    onClose: mobileNavOnClose,
    onOpen: mobileNavOnOpen,
  } = useDisclosure();

  return (
    <Box>
      <Box flex='1' h={'100vh'}>
        <Header mobileNavOnOpen={mobileNavOnOpen} />
        {children}
        <Footer />
        <MobileNav onClose={mobileNavOnClose} isOpen={mobileNavIsOpen} />
        <WhatsappClip />
        <CallAlfred />
      </Box>
    </Box>
  );
};

export default DrawerWrapper;
